import { render, staticRenderFns } from "./LeadLookup.vue?vue&type=template&id=496ac888&"
import script from "./LeadLookup.vue?vue&type=script&lang=ts&"
export * from "./LeadLookup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports